// extracted by mini-css-extract-plugin
module.exports = {"level_0":"Suggestions_level_0__58Qmu"};